
    /* general */
    // background_color: black;
    // frame_color: #3b424b;
    // /* frame_color: #14181D; */

    
    // frame_border_width: 4px;  
    // frame_border_width_position: _4px;
    // /* tabs */

    // tab_heading_color: #22272E;
    
    // /* tables */
    // table_headings_font_size: 15px;
    // table_heading_color: #252a3105;
    // table_heading_font_color: #8F96A0;
    // table_heading_height: 30px;
    
    // /* table_heading_border_color: # #13151A; */
    // table_row_font_size: 12px;
    // table_row_font: Verdana;
    // TABLE_ROW_BACKGROUND_COLOR: #020203;

    export const TABLE_ROW_BACKGROUND_COLOR = '#020203'
    export const TABLE_ROW_HIGHLIGHT = '#274368';
    
    // table_row_font_color: #0a030300;
    // table_row_alternate_color: #13151A;
    // table_row_border_color: #13151A;
    // table_row_border_width: 2px;
    // table_heading_col_padding: 3px;
    // table_heading_row_padding: 1px;
  